import React, {useState} from 'react'
import {Header, Button, Form, Search, Divider, Checkbox} from 'semantic-ui-react'
import Dialog from '../../dialog'
import useSWR  from 'swr'
import * as Yup from 'yup'
import {GlossaryFetcher, GlossarySave} from '../../../fetch/glossary'
import {marginL10, marginB10, marginB30, spanDiv, spanGrey, spanTransparent, panelBox, marginB4, allElements, selectedElements} from "../sidebar.module.scss"
import classNames from 'classnames'
import {getApiResponseErrorMessage} from '../../error'
import {fieldNames, options} from "../options"

const DataElementDialog = ({ title, open, loading, onSubmit, onClose, item }) => {

    const initialState = {
        loading: false,
        name: '',
        definition: '',
        status: '',
        type: 'data-element',
        id: null,
        dataType: '',
    }

    const [state, setState] = useState(initialState)
    const [selectedObject, setSelectedObject] = useState([]);
    const [selectedSampleValue, setSelectedSampleValue] = useState([]);
    const loadElements = React.useRef(true);
    const [dataObjects, setDataObjects] = useState(null);
    const [dataSampleValues, setDataSampleValues] = useState(null);

    const { data : objectList, errorObjects } = useSWR(!loadElements.current ? null : `/data-object/list`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(() => {
            if (objectList && objectList.data) setDataObjects(objectList.data)
    }, [objectList])

    const { data : valueList, errorValues } = useSWR(!loadElements.current ? null : `/sample-value/list`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(() => {
        if(valueList && valueList.data) setDataSampleValues(valueList.data)
    }, [valueList])


    React.useEffect(() => {
    if( item && item.id && (state.id === null || state.id !== item.id)) {
        if(item.dataObjects && item.dataObjects.length > 0) {
            const _tmpIndex =  item.dataObjects.map(i => i.id);
            setSelectedObject(item.dataObjects);
            if (dataObjects !== null && dataObjects.length > 0) {
                let _tmpO = dataObjects;
                _tmpO = dataObjects.filter(item => _tmpIndex.indexOf(item.id) < 0);
                setDataObjects(_tmpO);
            }
        }
        if(item.sampleValues && item.sampleValues.length > 0) {
            const _tmpIndex =  item.sampleValues.map(i => i.id);
            setSelectedSampleValue(item.sampleValues);
            if (dataSampleValues !== null && dataSampleValues.length > 0) {
                let _tmpSV = dataSampleValues;
                _tmpSV = dataSampleValues.filter(item => _tmpIndex.indexOf(item.id) < 0);
                setDataSampleValues(_tmpSV);
            }
        }
        setState( state => {
            return {
                name: item.name,
                definition: item.definition,
                status: item.status,
                id: item.id,
                type: 'data-element',
                dataType: item.dataType ? item.dataType.id : null,
                dataObjects: item.dataObjects ? item.dataObjects : null,
                sampleValues: item.sampleValues ? item.sampleValues : null
            }
        })
    }}, [item])

    const [errors, setError] = useState({})

    const [dataTypes, setDataTypes] = useState([]);

    const { data : typeList, error } = useSWR(`/data-type/list`, GlossaryFetcher, { errorRetryCount: 2 })
    React.useEffect(() => {
        if(typeList) {
            let _tmp = [];
            typeList.data && typeList.data.map((item, index) => {
                let tmp_item = {};
                tmp_item.text = item.name;
                tmp_item.value = item.id;
                _tmp.push(tmp_item);
                return null
            })
            setDataTypes(_tmp);
        }
    }, [typeList])

    const formSchema = Yup.object().shape({
        name: Yup.string().required(),
        definition: Yup.string().required(),
        status: Yup.string().required(),
        dataType: Yup.string().required(),
    });

    const handleInputChange = (e, {name, value}) => {

        if (errors[name] === true) {
            setError( errors => {
                return {
                    ...errors,
                    [name]: false
                }
            })
        }

        setState( state => {
            return {
                ...state,
                [name]: value
            }
        })

    }

    const [valueSampleValue, setValueSampleValue] = useState("");

    const [dataSampleValueSearch, setDataSampleValueSearch] = useState(null)

    const handleInputSearchSampleValue = (e, {value}) => {

        setValueSampleValue(value)

        if(value.trim() === " " || value.trim() === "" || value.trim() === null) {
            //setDataSampleValues(valueList.data);
            setDataSampleValueSearch(dataSampleValues)
        }
        else {
            let tmpSV = dataSampleValues && dataSampleValues.filter(item => {
                return item.name.toLowerCase().includes(value.toLowerCase())
            })
            //setDataSampleValues(tmpSV);
            setDataSampleValueSearch(tmpSV)
        }
    }

    const addSampleValue = (e) => {
        let _tmpSV = selectedSampleValue;
        _tmpSV.push(e)
        setSelectedSampleValue(_tmpSV);

        setDataSampleValues(dataSampleValues.filter(item => {
            return item.id !== e.id;
        }))
        setValueSampleValue("")
        setDataSampleValueSearch(null)
        loadElements.current = false;
    }

    const removeSampleValue = (e) => {
        const index = selectedSampleValue.indexOf(e);
        e.termRelationship && delete e.termRelationship;
        if (index > -1) {
            setSelectedSampleValue(selectedSampleValue.filter(item => {
                return item.id !== e.id;
            }));
            let _tempSV = dataSampleValues;
            _tempSV.push(e)
            setDataSampleValues(_tempSV);
        }
        setValueSampleValue("")
        setDataSampleValueSearch(null)
    }

    const setSampleValueRelationCB = (e) => {
        const index = selectedSampleValue.indexOf(e);
        if (index > -1) {
            setSelectedSampleValue(selectedSampleValue.map(item => {
                if(item.id === e.id) {
                    item.relationshipType = "constrained-by";
                    item.termRelationship && delete item.termRelationship;
                }
                return item
            }));
        }
    }

    const setSampleValueRelationDB = (e) => {
        const index = selectedSampleValue.indexOf(e);
        if (index > -1) {
            setSelectedSampleValue(selectedSampleValue.map(item => {
                if(item.id === e.id) {
                    item.relationshipType = "demonstrated-by";
                    item.termRelationship && delete item.termRelationship;
                }
                return item
            }));
        }
    }

    const [valueObject, setValueObject] = useState("");

    const [dataObjectsSearch, setDataObjectsSearch] = useState(null)
    const handleInputSearchObject = (e, {value}) => {

        setValueObject(value)

        if(value.trim() === " " || value.trim() === "" || value.trim() === null) {
            //setDataObjects(objectList.data);
            setDataObjectsSearch(dataObjects);
        }
        else {
            let tmpO = dataObjects && dataObjects.filter(item => {
                return item.name.toLowerCase().includes(value.toLowerCase())
            })
            //setDataObjects(tmpO);
            setDataObjectsSearch(tmpO);
        }
    }

    const addObject = (e) => {
        let _tmpO = selectedObject;
        _tmpO.push(e)
        setSelectedObject(_tmpO);

        setDataObjects(dataObjects.filter(item => {
            return item.id !== e.id;
        }))
        setValueObject("")
        setDataObjectsSearch(null)
        loadElements.current = false;
    }

    const removeObject = (e) => {
        const index = selectedObject.indexOf(e);
        if (index > -1) {
            setSelectedObject(selectedObject.filter(item => {
                return item.id !== e.id;
            }));
            let _tempO = dataObjects;
            _tempO.push(e)
            setDataObjects(_tempO);
        }
        setValueObject("")
        setDataObjectsSearch(null)
    }

    const handleOnSubmit = () => {

        setError({})

        formSchema.validate(state, {abortEarly: false}).then( data => {

            data.dataObjects = selectedObject.map(item => item.id);
            data.sampleValues = selectedSampleValue.map(item => {
                return {sampleValueId: item.id,
                    relationshipType: item.relationshipType ? item.relationshipType : item.termRelationship && item.termRelationship.type ? item.termRelationship.type : ""}
            });

            setState( state => {
                return {
                    ...state,
                }
            })


            // Callback
            if (typeof onSubmit === 'function') {
                const reply = GlossarySave(`/${state.type}/save`, data)

                reply.then(res => {
                    if (res.success === true) {
                        onSubmit()
                        setSelectedObject([]);
                        setSelectedSampleValue([]);
                        setState(state => initialState);
                        item = null;
                    }
                }).catch( error => {
                    const errorFields = {}

                    for (const [key, value] of Object.entries(error.response.data.messages)) {
                        errorFields[key] = getApiResponseErrorMessage({key: value, prefix: fieldNames[key]})
                    }

                    setError( err => {
                        return {
                            ...err,
                            ...errorFields
                        }
                    })
                    setState( state => {
                        return {
                            ...state,
                            dialogLoading: false,
                        }
                    })
                })
            }

        }).catch( errors => {

            console.log(errors)

            const errorFields = {}

            errors.inner.forEach( error => errorFields[error.path] = error.message.replace(error.path, fieldNames[error.path]))//true)

            setError( err => {
                return {
                    ...err,
                    ...errorFields
                }
            })

        })

    }

    const _onClose = () => {
        setSelectedObject([]);
        setSelectedSampleValue([]);
        setState(state => initialState);
        setError({})
        onClose()
    }

    if(loadElements.current === false) {
        loadElements.current = true;
    }

    return (
        <Dialog open={open} onClose={_onClose} closeOnEscape={false} closeOnDimmerClick={false}>

            <Form onSubmit={handleOnSubmit} loading={loading}>

                <Dialog.Header>
                    {title}
                </Dialog.Header>

                <Dialog.Content>

                    <Form.Group widths="equal">

                        <Form.Field>

                            <Form.Input
                                name="name"
                                error={errors.name}
                                label="Term name"
                                placeholder="Enter term name"
                                defaultValue={ item.name ? item.name : "" }
                                onChange={handleInputChange}
                            />

                            <br />

                            <Form.Select
                                name="dataType"
                                label="Data Type"
                                options={dataTypes}
                                error={errors.dataType}
                                search
                                placeholder="Select Data Type"
                                defaultValue={ item.dataType ? item.dataType.id : '' }
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <br />

                            <Form.Select
                                name="status"
                                label="Term status" options={options}
                                error={errors.status}
                                placeholder="Select Status"
                                defaultValue={ item.status ? item.status : '' }
                                onChange={handleInputChange}
                                icon={"chevron down"}
                            />

                            <div style={{marginTop: "32px"}}> </div>

                            <div className={classNames(panelBox, marginB30)}>
                                <Header as="h5" className={marginB4}>Add Data Objects (optional)</Header>
                                <Search
                                    className={"searchNoResults"}
                                    name="searchObjects"
                                    placeholder="Search Data Objects"
                                    onSearchChange={handleInputSearchObject}
                                    value={valueObject}
                                />
                                {selectedObject && selectedObject.length > 0 &&
                                    <>
                                    {/*<p className={classNames(pH, marginT10, marginB10)}> ADDED DATA OBJECTS</p>*/}
                                        <div className={selectedElements}>
                                            {selectedObject.map((i, index) => {
                                                return <div  className={marginB10} key={index}>
                                                    <Checkbox
                                                        checked = {true}
                                                        label={i.name}
                                                        onClick={() => removeObject(i)} />
                                                </div>
                                            })}
                                        </div>
                                    </>}
                                {dataObjectsSearch && dataObjectsSearch.length > 0 &&
                                    <>
                                        <Divider horizontal>Data Objects</Divider>
                                        <div className={allElements}>
                                            {dataObjectsSearch.map((i, index) => {
                                                return <div  className={marginB10} key={index}>
                                                    <Checkbox
                                                        checked = {false}
                                                        label={i.name}
                                                        onClick={() => addObject(i)} />
                                                </div>
                                            })}
                                        </div>
                                    </>}
                                {(!dataObjectsSearch) && dataObjects && dataObjects.length > 0 &&
                                    <>
                                        <Divider horizontal>Data Objects</Divider>
                                        <div className={allElements}>
                                            {dataObjects.map((i, index) => {
                                                return <div  className={marginB10} key={index}>
                                                    <Checkbox
                                                        checked = {false}
                                                        label={i.name}
                                                        onClick={() => addObject(i)} />
                                                </div>
                                            })}
                                        </div>
                                    </>}
                            </div>

                        </Form.Field>

                        <Form.Field>
                            <Form.TextArea
                                style = {{minHeight: "175px"}}
                                name="definition"
                                label="Term definition"
                                error={errors.definition}
                                defaultValue={ item.definition ? item.definition : "" }
                                onChange={handleInputChange}
                            />

                            <div style={{marginTop: "32px"}}> </div>

                            <div className={classNames(panelBox, marginB30)}>
                                <Header as="h5" className={marginB4}>Add Data Sample Values (optional)</Header>
                                <Search
                                    className={"searchNoResults"}
                                    name="searchSampleValue"
                                    placeholder="Search Sample Value"
                                    onSearchChange={handleInputSearchSampleValue}
                                    value={valueSampleValue}
                                />
                                {selectedSampleValue && selectedSampleValue.length > 0 &&
                                <>
                                {/*<p className={classNames(pH, marginT10, marginB10)}> ADDED DATA SAMPLE VALUES</p>*/}
                                    <div className={selectedElements}>
                                        {selectedSampleValue.map((i, index) => {
                                            return <div className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {true}
                                                    label={i.name}
                                                    onClick={() => removeSampleValue(i)} />
                                                <div className={classNames(
                                                    marginL10, spanDiv,
                                                    {[spanGrey]:(i.termRelationship && i.termRelationship.type === "constrained-by") || i.relationshipType === "constrained-by" },
                                                    {[spanTransparent]: (i.termRelationship && i.termRelationship.type === "demonstrated-by") || i.relationshipType === "demonstrated-by"})}
                                                     onClick={() => setSampleValueRelationCB(i)}>CB</div>
                                                <div className={classNames(
                                                    marginL10, spanDiv,
                                                    {[spanGrey]: (i.termRelationship && i.termRelationship.type === "demonstrated-by") || i.relationshipType === "demonstrated-by"},
                                                    {[spanTransparent]: (i.termRelationship && i.termRelationship.type === "constrained-by") || i.relationshipType === "constrained-by"})}
                                                     onClick={() => setSampleValueRelationDB(i)}>DB</div>
                                            </div>
                                        })}
                                    </div>
                                </>}

                                {dataSampleValueSearch && dataSampleValueSearch.length > 0 &&
                                <>
                                    <Divider horizontal>Sample Values</Divider>
                                    <div className={allElements}>
                                        {dataSampleValueSearch.map((i, index) => {
                                            return <div className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {false}
                                                    label={i.name}
                                                    onClick={() => addSampleValue(i)} />
                                            </div>
                                        })}
                                    </div>
                                </>}
                                {(!dataSampleValueSearch) && dataSampleValues && dataSampleValues.length > 0 &&
                                <>
                                    <Divider horizontal>Sample Values</Divider>
                                    <div className={allElements}>
                                        {dataSampleValues.map((i, index) => {
                                            return <div className={marginB10} key={index}>
                                                <Checkbox
                                                    checked = {false}
                                                    label={i.name}
                                                    onClick={() => addSampleValue(i)} />
                                                {/*<div className={classNames(
                                                    marginL10, spanDiv,
                                                    {[spanGrey]:(i.termRelationship && i.termRelationship.type === "constrained-by") || i.relationshipType === "constrained-by" },
                                                    {[spanTransparent]: (i.termRelationship && i.termRelationship.type === "demonstrated-by") || i.relationshipType === "demonstrated-by"})}
                                                     onClick={() => setSampleValueRelationCB(i)}>CB</div>
                                                <div className={classNames(
                                                    marginL10, spanDiv,
                                                    {[spanGrey]: (i.termRelationship && i.termRelationship.type === "demonstrated-by") || i.relationshipType === "demonstrated-by"},
                                                    {[spanTransparent]: (i.termRelationship && i.termRelationship.type === "constrained-by") || i.relationshipType === "constrained-by"})}
                                                     onClick={() => setSampleValueRelationDB(i)}>DB</div>*/}
                                            </div>
                                        })}
                                    </div>
                                </>}
                            </div>
                        </Form.Field>


                    </Form.Group>

                </Dialog.Content>

                <Dialog.Actions>
                    <Button type="submit" primary>
                        Submit
                    </Button>
                    <Button onClick={_onClose}>
                        Close
                    </Button>
                </Dialog.Actions>

            </Form>
        </Dialog>
    )

}


export default DataElementDialog